import Dexie from 'dexie'
import { EmailsTableType, emailsSchema } from 'shared/db/tables/emails'
import { FunnelsTableType, funnelSchema } from 'shared/db/tables/funnels'

type DexieTablesType = EmailsTableType & FunnelsTableType

type DexieType<T extends any = DexieTablesType> = Dexie & T

const database = new Dexie('dashboard-db') as DexieType

const schema = {
  ...emailsSchema,
  ...funnelSchema,
}

database.version(1).stores(schema)

export default database
